import { Component, OnInit, Output, EventEmitter, Inject, OnDestroy } from '@angular/core';
import { Router } from "@angular/router";
import { Subscription } from 'rxjs';

import { HeaderNavService } from "./header-nav.service";
import { SessionStorageService } from "../../../shared/services/session-storage.service";
import { SnackbarService } from "../../../shared/services/snackbar.service";
import { RestrictOutsideScrollService } from '../../services/restrict-outside-scroll.service';

import { config } from "../../../../../config/index";

@Component({
	selector: 'header-navigation',
	template: require('./header-nav.component.html'),
	styles: [require('./header-nav.component.less')],
	providers: [HeaderNavService, SnackbarService],
	preserveWhitespaces: true

})

export class HeaderNavComponent implements OnInit, OnDestroy {

	@Output() headerNavEvent: EventEmitter<any> = new EventEmitter<any>();
	@Output() updatePatientView: EventEmitter<any> = new EventEmitter<any>();

	notificationOpened: boolean = false;
	unreadMessages: boolean = false;
	notifications: any = [];
	actionRequiredListOpened: boolean = false;
	actionRequiredListItems: any = [];
	actionRequiredPendingCount: number = 0;
	private _role = config.role;
	private menu_list = config.menu_list;
	private roleSwitched = config.roleSwitched;
	_userRole: string;
	notSubscribedHideDropDown: boolean = false;
	selectedRole: any;
	userRoles: any = [];
	currentRoleData: any;
	sideBarOpened: boolean = false;

	apiSubscriptions: Subscription[] = [];
	markasReadSubscription: Subscription;

	constructor(
		private _router: Router,
		private _headerNavService: HeaderNavService,
		private _sessionStorageService: SessionStorageService,
		private _mdlSnackbarService: SnackbarService,
		private _restrictOutsideScrollService: RestrictOutsideScrollService,
		@Inject('utilService') private utilService: any
	) {
		this.utilService.hideHeaderNavDropDownNotSubscribed.subscribe(this.hideDropdownHeaderNav);
		this.utilService.userProfilePicUpdated.subscribe(this.updatedProfilePic);
		this.utilService.showActionRequiredListOnRedirection.subscribe(this.showActionRequiredList);
		this.utilService.actionRequiredListPendingCount.subscribe(this.updatePendingCount);
	}

	updatePendingCount = (data: any) => {
		if (data.count) {
			this.actionRequiredPendingCount = data.count;
		}
	}

	showActionRequiredList = (data: any) => {
		if (data.show) {
			this.actionRequiredListOpened = true;
		}
	}

	hideDropdownHeaderNav = (data: any) => {
		this.sideBarOpened = (data && data.opened);

		if (data.hide) {
			this.notSubscribedHideDropDown = true;
		}
	}

	/**
	* Function for header component  EventEmitter
	*/
	headerNavClick() {
		this.headerNavEvent.emit();
	}

	/**
	 * get notification list
	 */
	getNotification() {
		this.apiSubscriptions.push(this._headerNavService.getNotification()
			.subscribe((res: any) => {
				this.notifications = res.data;
				this.unreadMessages = false;
				if (res.extra.not_read_count > 0) {
					this.unreadMessages = true;
				}
			}, error => this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error'))
		);
	}

	notificationClicked() {
		if (this.actionRequiredListOpened) {
			this.actionRequiredListOpened = false;
		}
		this.notificationOpened = !this.notificationOpened;
		if (this.notificationOpened) {
			this.getNotification();
		}
	}

	actionRequiredListClicked() {
		if (this.notificationOpened) {
			this.notificationOpened = false;
		}
		this.actionRequiredListOpened = !this.actionRequiredListOpened;
		if (this.actionRequiredListOpened) {
			this._restrictOutsideScrollService.hideBackgroundScroll();
		} else {
			this._restrictOutsideScrollService.showBackgroundScroll();
		}
	}

	onClickOutside(eve: any) {
		if (eve && eve['value'] === true) {
			this.notificationOpened = false;
		}
	}

	/**
	 * mark as read
	 */
	markAsRead(id: any) {
		this.markasReadSubscription?.unsubscribe();
		this.markasReadSubscription = this._headerNavService.markAsRead(id)
			.subscribe((res: any) => this.getNotification(),
				error => this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error'));
	}

	/**
	 * redirect to logout
	 */
	routeLogout(data: any) {
		this._router.navigate([data]);
	}

	// route to notification url
	routeToNotificationUrl(notificationData: any) {
		this.markasReadSubscription?.unsubscribe();
		this.markasReadSubscription = this._headerNavService.markAsRead(notificationData.id)
			.subscribe((res: any) => this.getNotification(),
				error => this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error'));
		if (notificationData.page && window.location.href.indexOf('patient-file-view') !== -1 && notificationData.page === 'patient-file-view') {
			this._sessionStorageService.saveItem('viewPatientId', { 'id': notificationData.notification_data.id });
			this.updatePatientView.emit(notificationData.notification_data.id);
		} else if (notificationData.page && notificationData.page === 'practice-profile') {
			this._router.navigate(['pa-settings/practice-profile']);
		} else if (notificationData.page && notificationData.page === 'patient-referral-list') {
			this._router.navigate(['referral/patient-referral-list']);
		} else if (notificationData.page && notificationData.page !== 'patient-file-view') {
			this._router.navigate([notificationData.page + '/' + notificationData.notification_data.id]);
		} else if (notificationData.page && notificationData.page === 'patient-file-view') {
			this._sessionStorageService.saveItem('viewPatientId', { 'id': notificationData.notification_data.id });
			this._router.navigate(['patient/patient-file-view']);
		}
	}

	changeRole(event: any) {
		this.currentRoleData.selectedRole = event;
		this.currentRoleData.role = this.currentRoleData.selectedRole.name;
		this._sessionStorageService.saveItem(this._role, this.currentRoleData)
			.then(() => {
				this._sessionStorageService.saveItem(this.menu_list, { menuList: this.currentRoleData.selectedRole.menu_list })
					.then(() => {
						// set roleSwitched key to call login capture API after redirection
						this._sessionStorageService.saveItem(this.roleSwitched, true).then(() => {
							window.location.replace(location.origin + config.publicPath + "/home/dashboard");
						})
					});
			})
	}

	ngOnInit() {
		this._sessionStorageService.readItem(this._role).then((data: any) => {
			this.currentRoleData = data;
			this.userRoles = data.roles;
			this.selectedRole = data.selectedRole;
			this._userRole = data.role;

			// call login capture API based on roleSwitched key for tc, doctor, front office
			this._sessionStorageService.readItem(this.roleSwitched).then((data: any) => {
				if (data && (this._userRole === 'TC' || this._userRole === 'Doctor' || this._userRole === 'Front Office')) {
					this.apiSubscriptions.push(this._headerNavService.catureLogin().subscribe((res: any) => {
						this._sessionStorageService.saveItem(this.roleSwitched, false);
					}, error => this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error')));
				}
			});
		});

		this.getNotification();
	}

	updatedProfilePic = (data: any) => {
		if (data.profilePictureChange) {
			this._sessionStorageService.readItem(this._role).then(
				(data: any) => {
					this.currentRoleData = data;
					this.userRoles = data.roles;
					this.selectedRole = data.selectedRole;
					this._userRole = data.role;
				}
			);
		}
	}

	fetchdocContent(notification: any, action: string) {
		if (notification.notification_data?.is_file_response) {
			this.fetchPdfContent(notification, action);
		} else {
			this.fetchExcelDownload(notification);
		}
	}

	fetchPdfContent(notification: any, action: any) {
		this._headerNavService.getPdf(notification.notification_data.url.split('/backend/')[1]).subscribe((response) => {
			this.markAsRead(notification.id);
			if (action === 'view' || this.checkIsIOS()) {
				this.openPdfNewTab(response?._body);
			} else {
				this.downloadfile(response);
			}
		})
	}

	fetchExcelDownload(notification: any) {
		this._headerNavService.getExcel(notification.notification_data.url.split('/backend/')[1]).subscribe((response) => {
			this.markAsRead(notification.id);
			if (this.checkIsIOS()) {
				window.open(response.data.url, '_blank');
			} else {
				this.downloadFileUsingUrl(response.data.url);
			}
		})
	}

	openPdfNewTab(data: any) {
		const url = URL.createObjectURL(data);
		window.open(url, '_blank');
	}

	downloadFileUsingUrl(url: any) {
		const link = document.createElement('a');
		link.href = url;
		document.body.appendChild(link);
		link.click();
		link.parentNode.removeChild(link);
	}

	downloadfile(data: any) {
		const link = document.createElement('a');
		let binaryData: any = [];
		binaryData.push(data?._body);
		const contentType = data.headers.get('content-type');
		link.href = window.URL.createObjectURL(new Blob(binaryData, { type: contentType }));
		const contentDisposition = data.headers.get('content-disposition');
		link.download = this.getFilenameFromContentDisposition(contentDisposition);
		document.body.appendChild(link);
		link.click();
		link.parentNode.removeChild(link);
	}

	getFilenameFromContentDisposition(contentDisposition: any) {
		// Try to match RFC 5987 style: filename*=UTF-8''file%20name.pdf
		const encodedMatch = contentDisposition.match(/filename\*\s*=\s*([^']*)''([^;]+)/i);
		if (encodedMatch) {
			const charset = encodedMatch[1].toUpperCase();
			const encodedFilename = encodedMatch[2];

			if (charset === 'UTF-8') {
				try {
					return decodeURIComponent(encodedFilename);
				} catch (e) {
					console.warn("Failed to decode filename*: ", e);
				}
			} else {
				console.warn("Unsupported charset: ", charset);
			}
		}

		// Fallback to regular filename="file_name.pdf"
		const plainMatch = contentDisposition.match(/filename\s*=\s*"?([^"]+)"?/i);
		if (plainMatch) {
			return plainMatch[1];
		}

		// No filename found
		return 'decline.pdf';
	}

	ngOnDestroy() {
		// unsubscribe all subscriptions
		this.apiSubscriptions.forEach(subscription => subscription?.unsubscribe());
		this.markasReadSubscription?.unsubscribe();
	}

	checkIsIOS() {
		return /iPhone|iPad|iPod/.test(navigator.userAgent);
	}
}
